<template>
  <div>
    <div class="inner">
      <div class="header">
        <img @click="goBack" src="../../assets/close.svg" />
        <img class="points" src="../../assets/points.png" />
      </div>
      <div style="z-index:2;position:relative">
        <img
          :class="{
                'user-image' : true,
                'shrink' : !expandUser
                }"
          @click="$router.go(-1)"
          src="../../assets/user.svg"
          style="width: 40%;margin-top:-15%"
        />

        <div>
          <h2>@username</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HeaderProfile",
  methods: {
    goBack() {
      this.expandUser = false;
      window.setTimeout(() => {
        this.$router.go(-1);
      }, 180);
    }
  },
  data() {
    return {
      expandUser: true
    };
  }
};
</script>


<style lang="less" scoped>
.bg {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
h2 {
  margin-bottom: 20px;
}
@keyframes userimage {
  from {
    transform: scale(0.4) translate(-210%, -135%);
  }
  to {
    transform: scale(1) translate(0%, 0%);
  }
}

@keyframes userimager {
  from {
    transform: scale(1) translate(0%, 0%);
  }
  to {
    transform: scale(0.4) translate(-210%, -135%);
  }
}
.user-image {
  z-index: 10;
  animation: userimage 300ms linear;
}
.user-image.shrink {
  z-index: 10;
  animation: userimager 200ms linear forwards;
}
</style>